import { setPayload } from '@web-rendering/groundcontrol-store';
import { isPayload } from './helpers';
import type { Payload } from './types';

export abstract class PayloadService {
  abstract parse(rawPayload: unknown): Payload;

  validate(payload: unknown): payload is Payload {
    const result = isPayload(payload);
    if (!result.valid) {
      console.error('Validation failed:', result);
    }

    return result.valid;
  }

  initialize(rawPayload: unknown) {
    const parsedPayload = this.parse(rawPayload);

    setPayload(parsedPayload);

    return parsedPayload;
  }
}
